import { QueryStore } from '../runtime/stores/query'
import artifact from '$houdini/artifacts/inventoryTypeDetail'
import { initClient } from '$houdini/plugins/houdini-svelte/runtime/client'

export class inventoryTypeDetailStore extends QueryStore {
	constructor() {
		super({
			artifact,
			storeName: "inventoryTypeDetailStore",
			variables: true,
		})
	}
}

export async function load_inventoryTypeDetail(params) {
  await initClient()

	const store = new inventoryTypeDetailStore()

	await store.fetch(params)

	return {
		inventoryTypeDetail: store,
	}
}
